
import React, { createContext, useContext, useEffect } from 'react';
import { Session, User } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';
import { useUserStore, initializeUserStore, Profile } from '../store/useUserStore';

interface AuthContextType {
    session: Session | null;
    user: User | null;
    profile: Profile | null;
    loading: boolean;
    signOut: () => Promise<void>;
    refreshProfile: () => Promise<void>;
    // New helpers for convenience
    credits: number;
    isActive: boolean;
    isPro: boolean;
    isSuperAdmin: boolean;
}

export const AuthContext = createContext<AuthContextType>({
    session: null,
    user: null,
    profile: null,
    loading: true,
    signOut: async () => { },
    refreshProfile: async () => { },
    credits: 0,
    isActive: false,
    isPro: false,
    isSuperAdmin: false,
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    // Sync with Zustand store
    const {
        user,
        session,
        profile,
        loading,
        signOut,
        refreshProfile,
        credits,
        isActive,
        isPro,
        isSuperAdmin,
    } = useUserStore();

    // Initialize store on mount
    useEffect(() => {
        const cleanup = initializeUserStore();
        return cleanup;
    }, []);

    return (
        <AuthContext.Provider value={{
            session,
            user,
            profile,
            loading,
            signOut,
            refreshProfile,
            credits,
            isActive,
            isPro,
            isSuperAdmin,
        }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
